import { ReactElement } from 'react';
import ArrowUp from '@src/sld/components/ArrowUp/ArrowUp';
import VerticalLine from '@src/sld/components/Line/VerticalLine';

function Header(): ReactElement {
  return (
    <>
      <text
        x={685}
        y={60}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        115KV TOP GWF HANFORD SW
      </text>

      <text
        x={727}
        y={70}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        STATION
      </text>

      <ArrowUp xCoordinate={740} yCoordinate={90} />

      <VerticalLine
        translateXCoordinate={742.5}
        translateYCoordinate={90}
        length={55}
        color='white'
        width={0.5}
      />
    </>
  );
}

export default Header;
